import { render, staticRenderFns } from "./Type-device.vue?vue&type=template&id=722fe27f"
import script from "./Type-device.vue?vue&type=script&lang=ts"
export * from "./Type-device.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports